<template>
  <div class="dsf-readfilestructure">
    <div class="item">
      <div class="title">
        <i class="iconfont icon-wenjianjia"></i>
        <el-input placeholder="路径" v-model="rootPath" clearable readonly></el-input>
      </div>
      <el-table style="width: 100%" border stripe :data="tableData">
        <el-table-column width="auto" label="名称" align="left" prop="name" key="name">
          <template slot-scope="scope">
            <div @click="loadNextFile(scope.row)" :class="{ folder: scope.row.dir }">
              <i class="iconfont icon-wenjianjia" v-if="scope.row.dir"></i>
              {{ scope.row.name }}
            </div>
          </template>
        </el-table-column>
        <el-table-column width="auto" label="大小" align="left" prop="size" key="size"></el-table-column>
        <el-table-column width="auto" label="类型" align="left" prop="type" key="type"></el-table-column>
        <el-table-column width="auto" label="修改时间" align="left" prop="modifyTime" key="modifyTime"></el-table-column>
        <!-- <el-table-column width="auto" label="修改时间" align="left" prop="modifyTime" key="modifyTime"></el-table-column> -->
        <el-table-column width="auto" label="路径" align="left" prop="path" key="path"></el-table-column>
        <el-table-column width="auto" label="owner" align="left" prop="owner" key="owner"></el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
export default dsf.component({
  name: "DsfReadFileStructure",
  ctrlCaption: "文件列表",
  mixins: [$mixins.control],
  props: {
    name: {
      type: String,
      default: "",
    },
    ip: {
      type: String,
      default: "",
    },
    port: {
      type: String,
      default: "",
    },
    protocolValue: {
      type: String,
      default: "",
    },
    username: {
      type: String,
      default: "",
    },
    pwd: {
      type: String,
      default: "",
    },
    pathModeValue: {
      type: String,
      default: "",
    },
    path: {
      type: String,
      default: "",
    },
    fileName: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      sourceIdUrl: "/ftp/connectFtp/",
      sourceFilrUrl: "/ftp/listFile/",
      sourceCloseUrl: "/ftp/disConnectFtp",
      sourceId: null,
      tableData: [],
      rootPath: null,
    };
  },
  mounted() {
    this.loadFileSource();
  },
  methods: {
    loadNextFile(it) {
      const { dir, path } = it;
      if (dir) {
        this.loadFileDetail(path);
      }
    },
    async loadFileSource() {
      let res = await this.loadFileSourceId();
      if (res) {
        this.loadFileDetail();
      }
    },
    loadFileDetail(path) {
      const params = {
        connectId: this.sourceId,
        path: path || this.path,
      };
      this.$http
        .get(this.sourceFilrUrl, params)
        .done(({ success, data, message }) => {
          if (success) {
            this.tableData = data;
            this.rootPath = data.length === 0 ? null : data[0].path;
            console.log(data);
          } else {
            dsf.layer.message(message || "请求异常", false);
          }
        })
        .error(err => {
          dsf.error(err);
          dsf.layer.message(err.message || "请求异常", false);
        });
    },
    loadFileSourceId() {
      return new Promise((resolve, reject) => {
        /**
         * @params ip 地址
         * @params port 端口
         * @params protocolValue 协议值 ftp 1 sftp 0
         * @params username 用户名
         * @params pwd 密码
         * @params pathModeValue
         * @params path
         * @params fileName
         *
         */
        const params = {
          ip: this.ip,
          port: this.port,
          protocolValue: this.protocolValue,
          username: this.username,
          pwd: this.pwd,
        };
        this.$http
          .post(this.sourceIdUrl, params)
          .done(({ success, data, message }) => {
            if (success) {
              this.sourceId = data;
              resolve(data);
            } else {
              dsf.layer.message(message || "请求异常", false);
              reject(false);
            }
          })
          .error(err => {
            dsf.error(err);
            dsf.layer.message(err.message || "请求异常", false);
            reject(false);
          });
      });
    },
    closeSourceFtp() {
      return new Promise((resolve, reject) => {
        const params = {
          connectId: this.sourceId,
        };
        this.$http
          .post(this.sourceCloseUrl, params)
          .done(({ success, message }) => {
            if (success) {
              resolve(true);
            } else {
              dsf.layer.message(message || "请求异常", false);
              reject(false);
            }
          })
          .error(err => {
            dsf.layer.message(err.message || "请求异常", false);
            reject(false);
          });
      });
    },
    async yes() {
      const res = await this.closeSourceFtp();
      return res;
    },
  },
});
</script>
